/* Focus Hack — comportements sur mesure.
   1. Rangées horizontales : flèches de défilement.
   2. Menu mobile : les sous-menus ne s'ouvrent plus tout seuls. */

(function () {
  var PISTES = '.fh-grid3, .fh-pg, .fh-steps, .fh-rea, .fh-quatre';

  function brancher(car) {
    if (car.dataset.fhCar) return;
    var piste = car.querySelector(PISTES);
    var prev = car.querySelector('.fh-car__b--prev');
    var next = car.querySelector('.fh-car__b--next');
    if (!piste || !prev || !next) return;
    car.dataset.fhCar = '1';

    function pas() {
      var c = piste.firstElementChild;
      return c ? c.getBoundingClientRect().width + 14 : piste.clientWidth * 0.8;
    }
    prev.addEventListener('click', function () { piste.scrollBy({ left: -pas(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { piste.scrollBy({ left: pas(), behavior: 'smooth' }); });

    function maj() {
      var max = piste.scrollWidth - piste.clientWidth;
      var actif = max > 6;
      car.classList.toggle('fh-car--on', actif);
      prev.hidden = !actif || piste.scrollLeft <= 4;
      next.hidden = !actif || piste.scrollLeft >= max - 4;
    }
    piste.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
    setTimeout(maj, 250);
    setTimeout(maj, 1200);
  }

  function envelopper(piste) {
    if (piste.closest('.fh-car')) return;
    var car = document.createElement('div');
    car.className = 'fh-car';
    piste.parentNode.insertBefore(car, piste);
    car.appendChild(piste);
    car.insertAdjacentHTML('beforeend',
      '<button type="button" class="fh-car__b fh-car__b--prev" aria-label="Précédent"><svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg></button>' +
      '<button type="button" class="fh-car__b fh-car__b--next" aria-label="Suivant"><svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6"/></svg></button>');
  }

  function replierSousMenus(racine) {
    var zone = racine || document;
    zone.querySelectorAll('details[open]').forEach(function (d) {
      if (d.closest('.fh, .fh-a, .fh-b')) return;
      if (!d.closest('header, .header, .header-drawer, .menu-drawer, .drawer, dialog')) return;
      d.open = false;
    });
  }

  function surveillerTiroir() {
    document.querySelectorAll('.header-drawer, .menu-drawer, .drawer, dialog').forEach(function (t) {
      if (t.dataset.fhMenu) return;
      t.dataset.fhMenu = '1';
      new MutationObserver(function () {
        setTimeout(function () { replierSousMenus(t); }, 20);
      }).observe(t, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden', 'aria-expanded'] });
    });
  }

  function go() {
    document.querySelectorAll(PISTES).forEach(envelopper);
    document.querySelectorAll('.fh-car').forEach(brancher);
    replierSousMenus();
    surveillerTiroir();
  }

  if (document.readyState !== 'loading') go();
  else document.addEventListener('DOMContentLoaded', go);
  document.addEventListener('shopify:section:load', go);
  window.addEventListener('load', go);
})();
